import React from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaFacebookF, FaLinkedin, FaGithub } from "react-icons/fa";
import { SiTryhackme } from "react-icons/si";

const SocialMedia = () => (
  <div className="app__social">
    {/* <div>
      <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
        <BsInstagram />
      </a>
    </div> */}
    <div>
      <a
        href="https://www.linkedin.com/in/abdelmounim-mouadili-6bb946283"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedin />
      </a>
    </div>
    <div>
      <a
        href="https://github.com/momonaim"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaGithub />
      </a>
    </div>
    <div>
      <a
        href="https://tryhackme.com/p/diliabdel"
        target="_blank"
        rel="noopener noreferrer"
      >
        <SiTryhackme />
      </a>
    </div>
  </div>
);

export default SocialMedia;
